export class HideElementsConstants {
  public static HIDDEN_ELEMENT_FIRST_RELEASE = true;
}
